<template>
	<div class="leftres">
		<div>
			<div class="inputtop">
				<div v-for="(item, index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="seselect" :widthRight="item.widthRight" :widthLeft="item.widthLeft"
						:heightLeft="item.heightLeft" :heightRight="item.heightRight" :lablewith="item.lablewith"
						:options="item.options" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:multiple="item.multiple" :types="item.types" :inputtype="item.inputtype" :width="item.width"
						:event="item.event">
					</Commondropdownlist>
				</div>
				<div class="Btngroups">
					<CommonBtngroup :show="false" :qhide="false" @select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;"></div>
			</div>
			<div class="TableBox"
				style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<OrgStockMoneyChangeAdjustTable :tableData="tableData" :total="total"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					@Export="exportData">
				</OrgStockMoneyChangeAdjustTable>
			</div>
		</div>
	</div>
</template>

<script>
import Commondropdownlist from "../../../components/common-dropdownlist.vue";
import CommonBtngroup from "../../../components/commongroup.vue";
import OrgStockMoneyChangeAdjustTable from "./components/OrgStockMoneyChangeAdjustTable.vue";
import utils from "../../../common/utils";

import {
	OrgStockMoneyChangeAdjustList,
	OrgStockMoneyChangeAdjustExport
} from "@/api/OrgStockMoneyChangeAdjust";
import {
	InventoryClassList
} from '@/api/home'

export default {
	components: {
		Commondropdownlist,
		CommonBtngroup,
		OrgStockMoneyChangeAdjustTable,
	},
	data() {
		return {
			total: 0,
			pageindex: 1,
			pageSize: 20,
			tableData: [],
			form: {
				Year: '',
				Month: '',
				InvClass: '',
				CreateTime1: '',
				CreateTime2: ''
			},
			formdata: [{
				inputdata: "",
				title: "年度",
				fontSize: "14px",
				color: "#333333",
				placeholder: "请选择",
				types: "year",
				inputtype: "datey",
				width: "180px",
				lablewith: "48px",
			},
			{
				inputdata: "",
				title: "月份",
				fontSize: "14px",
				color: "#333333",
				placeholder: "请选择",
				types: "",
				inputtype: "select",
				width: "180px",
				lablewith: "117px",
				options: [{
					key: '1',
					value: '1月'
				}, {
					key: '2',
					value: '2月'
				}, {
					key: '3',
					value: '3月'
				}, {
					key: '4',
					value: '4月'
				}, {
					key: '5',
					value: '5月'
				}, {
					key: '6',
					value: '6月'
				}, {
					key: '7',
					value: '7月'
				}, {
					key: '8',
					value: '8月'
				}, {
					key: '9',
					value: '9月'
				}, {
					key: '10',
					value: '10月'
				}, {
					key: '11',
					value: '11月'
				}, {
					key: '12',
					value: '12月'
				}],
			},
			{
				inputdata: "",
				title: "产品线",
				fontSize: "14px",
				color: "#333333",
				placeholder: "全部",
				types: "",
				inputtype: "select",
				width: "180px",
				lablewith: "117px",
				options: [],
			},
			{
				inputdata: "",
				title: "创建时间",
				fontSize: "14px",
				color: "#333333",
				placeholder: "请选择",
				types: "daterange",
				inputtype: "date",
				width: "180px",
				lablewith: "117px",
			}
			],
		};
	},
	mounted() {
		this.inventoryClassList();
		this.getList();
	},
	methods: {
		// 获取产品线下拉
		async inventoryClassList() {
			let {
				code,
				data
			} = await InventoryClassList({})
			if (code == 0) {
				this.formdata[2].options = []
				data.data.map((item, index) => {
					let obj = {
						key: item.InvClass,
						value: item.InvClassName
					}
					this.formdata[2].options.push(obj)
				})
			}
		},
		// 列表
		async getList() {
			let {
				data,
				code
			} = await OrgStockMoneyChangeAdjustList({
				...this.form,
				pageSize: this.pageSize,
				pageIndex: this.pageindex,
			});
			if (code == 0) {
				this.total = data.Count;
				this.tableData = data.data;
			}
		},
		reset() {
			this.$refs.seselect.map((item, index) => {
				item.modelvalue = "";
				if (index === 3) { // CreateTime
					item.startTime = "";
					item.endTime = "";
				}
			});
			this.form = {
				Year: '',
				Month: '',
				InvClass: '',
				CreateTime1: '',
				CreateTime2: ''
			};
		},
		select() {
			this.pageindex = 1;
			// Year
			this.form.Year = this.$refs.seselect[0].modelvalue;
			// Month
			this.form.Month = this.$refs.seselect[1].modelvalue;
			// InvClass
			this.form.InvClass = this.$refs.seselect[2].modelvalue;
			// CreateTime
			this.form.CreateTime1 = this.$refs.seselect[3].startTime;
			this.form.CreateTime2 = this.$refs.seselect[3].endTime;

			this.getList();
		},
		handleCurrentChange(pageindex) {
			this.pageindex = pageindex;
			this.getList();
		},
		handleSizeChange(paegSzie) {
			this.pageSize = paegSzie;
			this.getList();
		},
		// 导出
		async exportData() {
			let resexprot = await OrgStockMoneyChangeAdjustExport({
				...this.form,
				pageSize: this.pageSize,
				pageIndex: this.pageindex,
			});
			if (resexprot) {
				utils.downloadFile(resexprot, "平台业务分析调整", "xlsx");
			} else {
				this.$message.warning("导出失败");
			}
		},
	},
};
</script>

<style lang="less" scoped>
.inputtop {
	width: 980px;
	height: 110px;
	box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
	background-color: #ffffff;
	padding-top: 15px;
	overflow: hidden;
	position: relative;
	transition: all 0.3s;
}

.Btngroups {
	display: inline-block;
	float: right;
	margin-top: 5px;
	margin-right: 0px;
}
</style>